import { z } from "zod";
import { START_DATE,END_DATE, NAME, STATUS } from "../consts";

export const schema = z.object({
  [NAME]: z.string().optional(),
  [STATUS]: z.string().optional(), // ✅ fix: boolean not string
  [START_DATE]: z.union([z.date(), z.string()]).optional(), // ✅ fix: accept Date or string
  [END_DATE]: z.union([z.date(), z.string()]).optional(),
});

export type formValues = z.infer<typeof schema>;
